import React, { useContext, useEffect, useState } from 'react';
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md';
import { useParams } from 'react-router';
import MainHeader from '../../Components/Header/MainHeader';
import EachProduct from '../../Components/Shopping/EachProduct';
import FiltersAndSorting from '../../Components/Shopping/FiltersAndSorting';
import { BASE_URL_API } from '../../References/URLs';
import AuthContext from '../../Store/AuthContext';
import styles from './ProductsListing.module.css';

const ProductsListing = () => {
    const { storeKey } = useParams();
    const [cartItems, setCartItems] = useState([]);
    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx?.isLoggedIn;
    const loginData = authCtx?.loginData ? JSON.parse(authCtx.loginData) : null;
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);

    const [products, setProducts] = useState([
        { productIdentifier: 1, productTitle: "Product 1", mrp: "$20", image: "https://via.placeholder.com/150", pointsOnSale: null },
        { productIdentifier: 2, productTitle: "Product 2", mrp: "$30", image: "https://via.placeholder.com/150", pointsOnSale: null },
        { productIdentifier: 3, productTitle: "Product 3", mrp: "$40", image: "https://via.placeholder.com/150" },
        { productIdentifier: 4, productTitle: "Product 4", mrp: "$50", image: "https://via.placeholder.com/150" },
        { productIdentifier: 5, productTitle: "Product 5", mrp: "$60", image: "https://via.placeholder.com/150" },
        { productIdentifier: 6, productTitle: "Product 6", mrp: "$70", image: "https://via.placeholder.com/150" },
    ]);

    const filtersData = {
        categories: [
            { name: 'Clothing', subCategories: ['Men', 'Women', 'Kids'] },
            { name: 'Footwear', subCategories: ['Sports', 'Casual', 'Formal'] }
        ],
        brands: ['Nike', 'Adidas', 'Puma', 'Reebok'],
        sizes: ['S', 'M', 'L', 'XL', 'XXL'],
        colors: [
            { name: 'Red', hex: '#FF0000' },
            { name: 'Blue', hex: '#0000FF' },
            { name: 'Green', hex: '#008000' },
            { name: 'Yellow', hex: '#FFFF00' },
            { name: 'Black', hex: '#000000' }
        ]
    };

    const [selectedFilters, setSelectedFilters] = useState({
        categories: [],
        brands: [],
        priceRange: [0, 1000],
        sizes: [],
        colors: []
    });
    const handleFilterToggle = (filterType, value) => {
        setSelectedFilters(prevFilters => {
            const isSelected = prevFilters[filterType].includes(value);
            const updatedFilters = isSelected
                ? prevFilters[filterType].filter(item => item !== value)
                : [...prevFilters[filterType], value];
            return { ...prevFilters, [filterType]: updatedFilters };
        });
    };

    const getProducts = async () => {
        const getProductsResponse = await fetch(BASE_URL_API + "getProducts", {
            method: "POST",
            body: JSON.stringify({ storeKey: storeKey }),
        });

        if (getProductsResponse.ok) {
            const response = await getProductsResponse.json();
            if (response.status === "success") {
                setProducts(response?.response);
            } else {
                setProducts([]);
                console.error(response);
            }
        } else {
            console.error("Server Error");
        }
    };

    useEffect(() => {
        getProducts();
    }, [storeKey]);

    const getCartItems = async () => {
        const getCartItemsResponse = await fetch(BASE_URL_API + "getCartItems", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                userIdentifier: loginData.userIdentifier,
            }),
        });

        if (getCartItemsResponse.ok) {
            const response = await getCartItemsResponse.json();
            if (response.status === "success") {
                setCartItems(response?.response);
            } else if (response.message === "Token Expired, please login again!") {
                authCtx.logout();
            } else {
                setCartItems([]);
            }
        } else {
            console.error("Server Error");
        }
    };

    useEffect(() => {
        if (isLoggedIn) {
            getCartItems();
        }
    }, [isLoggedIn]);

    return (
        <div>
            <MainHeader cartItems={cartItems} />
            {isFiltersOpen && (
                <FiltersAndSorting
                    isVisible={isFiltersOpen}
                    toggleIsVisible={() => setIsFiltersOpen(!isFiltersOpen)}
                />
            )}
            <div className={styles.container}>
                <div className={styles.contentWrapper}>
                    <aside
                        className={`${styles.filters} ${styles.animated}`}
                        style={{ position: 'sticky', top: '0', height: '88svh', overflowY: 'auto' }}
                    >
                        <div className={styles.filterTitle}>Filters</div>

                        {/* Categories */}
                        <div className={styles.filterSection}>
                            <div className={styles.sectionTitle} >Categories</div>
                            {filtersData.categories.map(category => (
                                <div key={category.name} className={styles.filterCategory}>
                                    <div onClick={() => handleFilterToggle('categories', category.name)} className={styles.categories} >
                                        {selectedFilters.categories.includes(category.name) ? <MdCheckBox size={22} color='#8D27B8' /> : <MdCheckBoxOutlineBlank size={22} color='#a5a5a5' />} {category.name}
                                    </div>
                                    <div className={styles.subCategories}>
                                        {category.subCategories.map(sub => (
                                            <div key={sub} onClick={() => handleFilterToggle('categories', sub)} className={styles.eachSubCategory} >
                                                {selectedFilters.categories.includes(sub) ? <MdCheckBox size={22} color='#8D27B8' /> : <MdCheckBoxOutlineBlank size={22} />} {sub}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Brands */}
                        <div className={styles.filterSection}>
                            <div className={styles.sectionTitle} >Brand</div>
                            <div className={styles.subCategories}>
                                {filtersData.brands.map(brand => (
                                    <div key={brand} className={styles.eachSubCategory} onClick={() => handleFilterToggle('brands', brand)}>
                                        {selectedFilters.brands.includes(brand) ? <MdCheckBox size={22} color='#8D27B8' /> : <MdCheckBoxOutlineBlank size={22} />} {brand}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Price Range */}
                        <div className={styles.filterSection}>
                            <div className={styles.sectionTitle} >Price Range</div>
                            <div className={styles.subCategories}>
                            <input type="range" min="0" max="500" step="10" color="#8D27B8" />
                        </div>
                        </div>

                        {/* Sizes */}
                        <div className={styles.filterSection}>
                            <div className={styles.sectionTitle} >Size</div>
                            <div className={styles.subCategories}>
                                {filtersData.sizes.map(size => (
                                    <div key={size} onClick={() => handleFilterToggle('sizes', size)} className={styles.eachSubCategory}>
                                        {selectedFilters.sizes.includes(size) ? <MdCheckBox size={22} color='#8D27B8' /> : <MdCheckBoxOutlineBlank size={22} />} {size}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Colors */}

                        <div className={styles.filterSection}>
                            <div className={styles.sectionTitle} >Color</div>
                            <div className={styles.colorOptions}>
                                {filtersData.colors.map(color => (
                                    <div key={color.name} className={styles.colorTile}
                                        onClick={() => handleFilterToggle('colors', color.name)}>
                                        <div style={{ backgroundColor: color.hex }} className={styles.eachColorTile} >
                                        </div>
                                        <div className={styles.colorName} >
                                            {selectedFilters.colors.includes(color.name) ? <MdCheckBox color='#8D27B8' /> : <MdCheckBoxOutlineBlank />} {color.name}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </aside>

                    <div className={styles.grid} style={{ paddingBottom: '80px' }}>
                        {products.map((product) => (
                            <EachProduct
                                key={product.productIdentifier}
                                product={product}
                                cartItems={cartItems}
                                getCartItems={getCartItems}
                            />
                        ))}
                    </div>
                </div>
                <div className={styles.sortFilterBtns}>
                    <button className={styles.btn}>Sort</button>
                    <button className={styles.btn} onClick={() => setIsFiltersOpen(true)}>
                        Filter
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductsListing;
